import * as actions from './payment.actions'
import { identity } from 'fp-ts/lib/function'
import { Reducer } from 'src/framework'
// import { Lens } from 'monocle-ts'
// import { none, Option, some } from 'fp-ts/lib/Option'

export interface PaymentState {}

export const initialPaymentState: PaymentState = {}

export const sameState: (s: PaymentState) => PaymentState = identity

export const paymentReducer: Reducer<actions.PaymentActions, PaymentState> = actions.paymentActions.match({
  default: _action => sameState
})



// WEBPACK FOOTER //
// ./src/payment/payment.reducer.ts